import axios from 'axios';
import BaseAPIService from '@/services/APIService';

const APIService = axios.create({
  baseURL: process.env.VUE_APP_DIRECTORY_URL_V1,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  getInstructions(params) {
    return APIService.get('/service-helps', { params });
  },
  getInstruction(id, params) {
    return APIService.get(`/service-helps/${id}`, { params });
  },
  loadKeywords({ key }) {
    return APIService.get(
      '/directory-search-keywords/list', { search: key },
    );
  },
  // Уровень подчиненности
  subordinationLevels() {
    return APIService.get('/directory-subordination-levels');
  },
  // Типы образовательных организаций
  providerTypes() {
    return APIService.get('/additional-provider-types');
  },
  // Департаменты
  departments(params) {
    return APIService.get('/directory-departments', { params });
  },
  // Муниципалитеты
  municipalities(params) {
    return APIService.get('/municipalities', { params });
  },
  municipalityShow(id, params) {
    return APIService.get(`/municipalities/${id}`, { params });
  },
  // Регионы
  regions(params) {
    return APIService.get('/regions', { params });
  },
  regionShow(id, params) {
    return APIService.get(`/regions/${id}`, { params });
  },
  // Организации
  organizations(params) {
    return BaseAPIService.get('/organizations', { params });
  },
  organizationShow(id, params) {
    return BaseAPIService.get(`/organizations/${id}`, { params });
  },
  // Организационно-правовые формы
  departmentsOrganizationalForms() {
    return APIService.get('/directory-organizational-forms');
  },
  // Направленность программы
  programDirections() {
    return APIService.get('/directory-program-directions');
  },
  programDirectionShow(id) {
    return APIService.get(`/directory-program-directions/${id}`);
  },
  // Направленность программы
  teacherPositions(params) {
    return APIService.get('/teacher-positions', { params });
  },
  // Уровни образования педагогов
  teacherLevels() {
    return APIService.get('/teacher-levels');
  },
  // Профессиональные категории педагогов
  teacherCategories() {
    return APIService.get('/teacher-categories');
  },
  // Уровни соответствия квалификации
  teacherSkillLevels() {
    return APIService.get('/teacher-skill-levels');
  },
  // Достижения преподавателей
  teacherAwards() {
    return APIService.get('/teacher-awards');
  },
  // Справочник документов программ
  progDocumentTypes() {
    return APIService.get('/directory-program-documents');
  },
  // Виды деятельности для программ
  progActivities(params) {
    return APIService.get('/directory-program-activities', { params });
  },
  // Виды деятельности для программ (автокомплит)
  progActivitiesFiltered(name) {
    return APIService.get(
      `/directory-program-activities?search[name]=${name}`,
    );
  },
  // Виды деятельности для программ (по id)
  programActivity(id) {
    return APIService.get(
      `/directory-program-activities/${id}`,
    );
  },
  // Список интересов для программ (автокомплит)
  programInterests(params) {
    return APIService.get(
      '/directory-interests', params,
    );
  },
  // Средства обучения (автокомплит)
  learningToolsFiltered(name) {
    return APIService.get(
      `/directory-learning-tools?search[name]=${name}`,
      { status: 1 },
    );
  },
  // Средство обучения по ID
  learningToolById(id) {
    return APIService.get(
      `/directory-learning-tools/${id}?expand=unity,categories`,
    );
  },
  // Ключевые слова (автокомплит)
  keywordsFiltered(name) {
    return APIService.get(
      `/directory-search-keywords/list?search=${name}`,
    );
  },
  // Ключевые слова (автокомплит)
  keywordsFaqFiltered(name) {
    return APIService.get(
      '/faq-keywords',
      { 'search[name]': name },
    );
  },
  // Заболевания
  illnesses() {
    return APIService.get('/illnesses');
  },
  // информация о платных модулях
  getModulesInfo(params) {
    return APIService.get('/directory-pay-modules', { params });
  },
  // справочник причин отказов
  moderationRefuseReasons() {
    return APIService.get('directory-refuse-reasons');
  },

  specialitiesGroups(params) {
    return APIService.get('/specialities-groups', { params });
  },
  professionalActivities(params) {
    return APIService.get('professional-activities', { params });
  },
};
